<template>
  <main role="main">
    <b-container>
      <div v-if="isLoading" class="py-5 text-secondary text-center">{{ $t("loadingData") }}</div>
      <template v-else-if="meeting">
        <div v-if="!['END', 'CANCEL'].includes(meeting.status)" class="text-center py-5">
          <template v-if="appDeepLink && appDownloadLink && isMobile">
            <div class="download-container" v-if="meeting.version">
              <img class="mb-4" style="width: 256px; height: 256px" src="images/app-logo.jpg" alt="app logo">
              <div class="mb-3">
                <b-button block variant="primary" :href="appDeepLink">{{ $t("openInApp") }}</b-button>
              </div>
              <div>
                <b-button block variant="success" :href="appDownloadLink">{{ $t("downloadApp") }}</b-button>
              </div>
            </div>

            <div class="mb-3" v-if="!meeting.version">
              <div class="text-center text-secondary">
               <h2>{{ meeting.name }}</h2>
              </div>
              <span class="text-secondary mr-2">{{ $t("status") }}:</span>
              <b-badge :variant="statusBadgeVariant[meeting.status]">
                {{ statusText[meeting.status] }}
              </b-badge>
            </div>
          </template>
          <template v-else-if="coreVersion == 'v3' && sessionToken">
            <div class="download-container">
              <img class="mb-4" style="width: 256px; height: 256px" src="images/app-logo.jpg" alt="app logo">
              <div class="mb-3">
                <b-button block variant="primary" :href="joinUrl">{{ $t("openInBrowser") }}</b-button>
              </div>
              <div class="mb-3">
                <b-button block variant="warning" :href="appDeepLink">{{ $t("openInApp") }}</b-button>
              </div>
              <div class="mb-3">
                <b-button block variant="success" :href="appDownloadLink">{{ $t("downloadApp") }}</b-button>
              </div>
              <!-- Ẩn upcode prod -->
              <!-- <div>
                <b-button block variant="primary" @click="openWidget">Mở Widget</b-button>
              </div> -->
            </div>
          </template>
          <template v-else>
            <h4>{{ meeting.name }}</h4>
            <div class="mb-3">
              <span class="text-secondary mr-2">{{ $t("status") }}:</span>
              <b-badge :variant="statusBadgeVariant[meeting.status]">
                {{ statusText[meeting.status] }}
              </b-badge>
            </div>

            <b-form class="text-left" id="join-meeting-form" @submit.prevent="submitForm">
              <b-form-group label-for="input-full-name">
                <template v-slot:label>{{ $t("fullName") }} <span class="text-danger">*</span></template>
                <b-form-input id="input-full-name" type="text" required minlength="2" maxlength="100" v-model="fullName"
                  :disabled="isSubmitting" />
              </b-form-group>
              <b-form-group v-if="shouldShowOrgField" :label="$t('workOrganizationName')" label-for="input-org-name">
                <b-form-input id="input-org-name" type="text" maxlength="100" v-model="orgName"
                  :disabled="isSubmitting" />
              </b-form-group>
              <b-form-group label-for="input-access-code">
                <template v-slot:label>{{ $t("enterAccessCode") }} <span class="text-danger">*</span></template>
                <b-form-input id="input-access-code" type="text" class="text-monospace" required minlength="2"
                  maxlength="32" v-model="accessCode" :disabled="isSubmitting" />
              </b-form-group>
              <div v-if="formErrorMsg" class="text-danger mb-3">{{ $t(formErrorMsg) }}</div>
              <b-button block type="submit" variant="primary" :disabled="isSubmitting">{{ $t("joinMeeting") }}
              </b-button>
            </b-form>
          </template>
        </div>
        <div v-else class="text-center py-5">
          <div class="text-center text-secondary">
            <h2>{{ meeting.name }}</h2>
          </div>
          <div class="mb-3">
              <span class="text-secondary mr-2">{{ $t("status") }}:</span>
              <b-badge :variant="statusBadgeVariant[meeting.status]">
                {{ statusText[meeting.status] }}
              </b-badge>
            </div>
        </div>
      </template>
      <div class="text-center text-danger py-5" v-if="errorMsg">{{ $t(errorMsg) }}</div>
      <gomeet-widget v-if='sessionToken != null && sessionToken != "" && haveWidget' id="gomeet-widget-edge" 
      :sessionToken="sessionToken" i-width-max="350" i-width-min="350" i-height-min="350" i-height-max="400"></gomeet-widget>
    </b-container>
  </main>
</template>

<style lang="scss" scoped>
#join-meeting-form,
.download-container {
  display: inline-block;
  width: 300px;
}
</style>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import _ from "lodash";
import BaseComponent from "@/components/BaseComponent";

import * as meetingService from "@/service/meetingService";
import * as util from "@/service/util";
import UAParser from "ua-parser-js";


@Component
export default class JoinMeetingForm extends BaseComponent {

  readonly statusText = {
    PENDING: this.$t("meetingStatusPending").toString(),
    INPROGRESS: this.$t("meetingStatusInProgress").toString(),
    END: this.$t("meetingStatusEnded").toString(),
    CANCEL: this.$t("meetingStatusCancelled").toString(),
  };

  readonly statusBadgeVariant = {
    PENDING: "warning",
    INPROGRESS: "success",
    END: "secondary",
    CANCEL: "danger"
  };

  meetingSecretKey: string = null;

  isLoading = true;
  meeting = null;
  errorMsg = "";

  shouldShowOrgField = false;
  fullName = "";
  orgName = "";
  accessCode = "";
  ver = "";

  formErrorMsg = "";
  isSubmitting = false;

  appDeepLink = "";
  appDownloadLink = "";
  isMobile = false;
  coreVersion = "";
  sessionToken = "";
  joinUrl = "";

  haveWidget = false;

  mounted() {
    this.meetingSecretKey = decodeURIComponent(this.$route.params.meetingSecretKey);
    this.shouldShowOrgField = this.$route.meta?.mayHaveOrgField && window["vnptEConferencePortalJoinMeetingWithOrgName"];
    this.accessCode = this.$route.query.accessCode?.toString().trim() || "";
    this.accessCode = this.accessCode.split(' ')[0].trim();
    this.ver = this.$route.query.v?.toString().trim() || "";
    this.fullName = this.$route.query.fullName?.toString() || "";

    const uap = new UAParser();
    const osname = uap.getOS().name.toLowerCase();
    if(osname == "mac os" && uap.getDevice().type == "tablet") {
      this.isMobile = true;
    }
    else {
      this.isMobile = ["android", "ios"].includes(osname);
    }
    this.fetchMeeting();
  }

  openWidget() {
    this.haveWidget = true;
    //   var ifrm = document.createElement("iframe");
        
      //   ifrm.setAttribute("src", "https://gomesainterf05.vnpt.vn/widget?sessionToken="+ this.sessionToken+"&clientdomain="+window.origin);
      //   ifrm.setAttribute("id", "iframeCheck1");
      //   ifrm.setAttribute("scrolling", "no");
      //   ifrm.setAttribute("width", "400");
      //   ifrm.setAttribute("height", "325");
      //   ifrm.setAttribute("allow", "autoplay; camera; microphone; display-capture");
      //   ifrm.setAttribute("frameborder", "0");
      //   ifrm.setAttribute("allowfullscreen", "");
      //   ifrm.setAttribute("style", "position: fixed; bottom: 0px; right: 0px; min-height: 325px; min-width: 400px; border-radius: 1em; z-index: 2050;");
      //   document.body.appendChild(ifrm);
      //   window.onmessage = event => {
      //     if(event.origin=="https://gomesainterf05.vnpt.vn") {
      //       let ifr = document.getElementById("iframeCheck1");
      //       switch (event.data) {
      //         case "expand":
      //           ifr.style.width = "100vw";
      //           ifr.style.height= "100vh";
      //           ifr.style.width = "90vw";
      //           ifr.style.height = "90vh";
      //           ifr.style.right = "50px";
      //           ifr.style.bottom = "50px";
      //           break;
            
      //         case "exitWidget":
      //         ifr.parentNode.removeChild(ifr);
      //         default:
      //           ifr.style.width = "400px";
      //           ifr.style.height= "300px";
      //           ifr.style.right = "0";
      //           ifr.style.bottom = "0";
      //           break;
      //       }
      //     }
      // }
  }

  unmounted() {
    var evt = new CustomEvent("versionChange", { detail: { type: null } });
      window.dispatchEvent(evt);
  }


  async fetchMeeting() {
    try {
      this.isLoading = true;
      this.meeting = await meetingService.getBySecretKey(this.meetingSecretKey);
      this.coreVersion = this.meeting.version;
      var evt = new CustomEvent("versionChange", { detail: { type: this.coreVersion } });
      window.dispatchEvent(evt);
      if (this.coreVersion == 'v2') {
        this.handleV2Deeplink();
      } else {
        this.handleV3Deeplink();
      }
    } catch (e) {
      this.errorMsg = e.response?.data?.code || e.code;

    } finally {
      this.isLoading = false;
    }
  }

  handleV2Deeplink() {
    const ua = navigator.userAgent;
    if (/android/i.test(ua)) {
      this.appDownloadLink = "https://play.google.com/store/apps/details?id=vn.vnptit.gomeet";
    } else if (/iPad|iPhone|iPod/.test(ua) && !window["MSStream"]) {
      this.appDownloadLink = "https://apps.apple.com/us/app/vnpt-gomeet/id1588855631";
    }

    if (this.appDownloadLink) {
      if (!document.head.querySelector(`meta[name="viewport"]`)) {
        const metaTag = document.createElement('meta');
        metaTag.name = "viewport";
        metaTag.content = "width=device-width,initial-scale=1.0";
        document.head.appendChild(metaTag);
      }
      const url = new URL(location.href);
      url.search = "";
      this.appDeepLink = "gomeet://gomeeting.vnpt.vn/?url=" + url.href;
    }
  }
  handleV3Deeplink() {
    const uap = new UAParser();
    const osname = uap.getOS().name.toLowerCase();

    if (["mac os", "macos", "mac"].includes(osname) && uap.getDevice().type != "tablet") {
      this.appDownloadLink = window["vnptEConferencePortalAppDownloadLinks"].macos;

    } else if (osname === "android") {
      this.appDownloadLink = window["vnptEConferencePortalAppDownloadLinks"].android;

    } else if (osname === "ios" || ["mac os", "macos", "mac"].includes(osname) && uap.getDevice().type == "tablet") {
      this.appDownloadLink = window["vnptEConferencePortalAppDownloadLinks"].ios;

    } else if (osname.includes("windows")) {
      this.appDownloadLink = window["vnptEConferencePortalAppDownloadLinks"].windows;

    } else if (navigator.userAgent.toLowerCase().includes("linux")) {
      this.appDownloadLink = window["vnptEConferencePortalAppDownloadLinks"].linux;
    }

    if (this.appDownloadLink) {
      if (!document.head.querySelector(`meta[name="viewport"]`)) {
        const metaTag = document.createElement('meta');
        metaTag.name = "viewport";
        metaTag.content = "width=device-width,initial-scale=1.0";
        document.head.appendChild(metaTag);
      }

      var usp = new URLSearchParams({
        roomId: this.meetingSecretKey,
        accessCode: this.accessCode,
        name: util.joinStrings([this.fullName, this.orgName], " ")
      });
      if(this.ver != ""){
        usp = new URLSearchParams({
          roomId: this.meetingSecretKey,
          accessCode: this.accessCode,
          v : this.ver,
          name: util.joinStrings([this.fullName, this.orgName], " ")
        });
      }
      this.appDeepLink = `gomeetv3://${location.host}?${usp.toString()}`;
    }
  }

  async submitForm() {
    try {
      this.isSubmitting = true;
      this.formErrorMsg = null;

      const res = await meetingService.joinBySecretKeyAndName({
        meetingSecretKey: this.meetingSecretKey,
        fullName: this.fullName.trim() || undefined,
        org: this.orgName.trim() || undefined,
        accessCode: this.accessCode,
      });
      this.sessionToken = res.sessionToken;
      if (this.sessionToken) {
        this.joinUrl = res.joinUrl;
        this.coreVersion = 'v3';
        this.appDeepLink = window["vnptEConferencePortalV3AppDeepLinkPrefix"] + this.sessionToken;
        this.handleV3Deeplink();

        if (!this.appDownloadLink) {
          location.href = res.joinUrl;
        }

      } else {
        location.href = res.joinUrl;
      }
    } catch (e) {
      this.formErrorMsg = e.response?.data?.code || e.code;

    } finally {
      this.isSubmitting = false;
    }
  }

}
</script>
